import { render } from "./LessonHeaderComponent.vue?vue&type=template&id=3e8b6d4a"
import script from "./LessonHeaderComponent.vue?vue&type=script&lang=js"
export * from "./LessonHeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__